<template>
<v-row justify="center">
	<v-dialog
		transition="dialog-top-transition"
		v-model="localValue"
		max-width="500"
		:persistent="persistent">
		<v-card>
			<v-card-title>
				{{title}}
			</v-card-title>
			<v-card-text>{{message}}</v-card-text>
			<v-card-actions class="pt-0">
				<!--
					يتم قدحه عن النقر على زر موافق
					@event close
				-->
				<v-btn
					:color="confirmButtonColor ? confirmButtonColor : 'greenDarken1'"
					text
					@click="$emit('close')"
				>
					{{$t('ok')}}
				</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
    </v-dialog>
</v-row>
</template>
<script>
/**
 * @displayName bee-confirm-dialog
 * 
 * @example ../../../../../docs/components/beeConfirmDialog.md
 */
export default {
props: {
	/** بإمكانك التحكم بظهور الـ dialog أو إخافئه */
	value:{},

	/** تحديد عنوان الـ dialog */
	title:{},

	/** الرسالة التي سيتم عرضها داخل الـ dialog */
	message:{},

	/** منع إغلاق الـ dialog عند النقر خارجه */
	persistent:{},

	/** تغيير لون زر التأكيد */
	confirmButtonColor:{}
},
name: "BeeConfirmDialog", 
computed: {
    localValue: {
        get: function () {
            return this.value
        },
        set: function (value) {
			/**
			 *  هذا الحدث اُستخدم تمرير الـ value من v-dialog إلى bee-confirm-dialog
			 * @property {} value - dialog حالة الـ
			 */
			this.$emit('input', value)
        }
    }  
},
	
	i18n: {
		messages: {
			ar: { ok: 'موافق'},
			en: { ok: 'OK'},
			es: { ok: 'Ok'},
		}
	}
}
</script>